// document.addEventListener('DOMContentLoaded', () => {
//   document.querySelectorAll('.sf-mixed-layout__wrapper').forEach(wrapper => {
//     const isSwiper = wrapper.classList.contains('swiper-wrapper') || wrapper.closest('.swiper-wrapper');
//     const products = isSwiper 
//       ? Array.from(wrapper.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)'))
//       : Array.from(wrapper.children);

//     if (products.length <= 1) return;

//     const seen = new Set();
//     const firstProducts = [], duplicateProducts = [];

//     products.forEach(product => {
//       let productKey = product.dataset.productId || 
//                        product.dataset.productId__c || 
//                        product.querySelector('a[href*="/products/"]')?.href.split('/products/').pop()?.split('?')[0];

//       if (!productKey) productKey = product.textContent.trim().substring(0, 50);

//       if (!seen.has(productKey)) {
//         seen.add(productKey);
//         firstProducts.push(product);
//       } else {
//         duplicateProducts.push(product);
//       }
//     });

//     for (let i = firstProducts.length - 1; i > 0; i--) {
//       const j = Math.floor(Math.random() * (i + 1));
//       [firstProducts[i], firstProducts[j]] = [firstProducts[j], firstProducts[i]];
//     }

//     const arrangedProducts = firstProducts.concat(duplicateProducts);

//     if (isSwiper) {
//       const swiper = wrapper.closest('.swiper-container')?.swiper;
//       if (swiper) {
//         swiper.removeAllSlides();
//         swiper.appendSlide(arrangedProducts);
//         swiper.update();
//       }
//     } else {
//       wrapper.innerHTML = '';
//       arrangedProducts.forEach(product => wrapper.appendChild(product));
//     }
//   });
// });
document.addEventListener('DOMContentLoaded', () => {
  const wrappers = document.querySelectorAll('.sf-mixed-layout__wrapper');
  if (!wrappers.length) return;

  wrappers.forEach(wrapper => {
    const isSwiper = wrapper.classList.contains('swiper-wrapper') || wrapper.closest('.swiper-wrapper');
    const productElements = isSwiper 
      ? wrapper.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)')
      : wrapper.children;

    const products = Array.from(productElements);
    if (products.length <= 1) return;

    const seen = new Set();
    const unique = [];
    const duplicates = [];

    for (let product of products) {
      let productKey = product.dataset.productId || product.dataset.productId__c;
      if (!productKey) {
        const link = product.querySelector('a[href*="/products/"]');
        if (link) {
          const match = link.href.match(/\/products\/([^/?#]+)/);
          if (match) productKey = match[1];
        }
        if (!productKey) productKey = product.textContent.trim().slice(0, 50);
      }

      (seen.has(productKey) ? duplicates : unique).push(product);
      seen.add(productKey);
    }

    // Fisher-Yates shuffle
    for (let i = unique.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [unique[i], unique[j]] = [unique[j], unique[i]];
    }

    const allProducts = [...unique, ...duplicates];

    if (isSwiper) {
      const swiper = wrapper.closest('.swiper-container')?.swiper;
      if (swiper) {
        swiper.removeAllSlides();
        swiper.appendSlide(allProducts);
        swiper.update();
      }
    } else {
      const fragment = document.createDocumentFragment();
      allProducts.forEach(product => fragment.appendChild(product));
      wrapper.replaceChildren(fragment);
    }
  });
});


